export { default } from './CardActionArea';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/CardActionArea/index.js
// module id = 814
// module chunks = 2